<template>
  <div class="commercial-print-create">
    <app-view-layout header="Nowy Akcydens NBP">
      <template #content>
        <v-form
          ref="createCommercialPrintForm"
          v-model="isFormValid"
          @submit.prevent="submit"
        >
          <CPFormCard
            v-model="commercialPrint"
            class="mt-4 mb-8"
          />

          <AppTextCard
            v-model="commercialPrint.description"
            required
            class="mb-8"
            title="Opis projektu *"
          />

          <ProjectFilesCard
            ref="commercialPrintFiles"
            :files="files"
            hide-tabs
            disable-download
            :processing="isProcessing"
            @add="showFileAddDialog"
            @delete="deleteFiles"
          />

          <v-btn
            class="my-8"
            color="primary"
            type="submit"
            height="40"
            max-width="160"
            :loading="isProcessing"
          >
            Utwórz akcydens
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import CPFormCard from '@/components/CommercialPrint/CPFormCard.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import ProjectFilesCard from '@/components/Projects/ProjectFilesCard.vue';
import TemplateSelected from '@/components/Projects/TemplateSelected.vue';

export default {
  components: {
    AppViewLayout,
    CPFormCard,
    AppTextCard,
    ProjectFilesCard,
    TemplateSelected,
  },

  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    fromArchive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rules: validationRules,
      isFormValid: true,
      commercialPrint: {
        name: '',
        commercialPrintType: '',
        deadline: '',
        description: '',
        location: '',
        printCoordination: false,
      },
    };
  },

  computed: {
    ...mapState('commercialPrintSingle', ['isProcessing']),
    ...mapState('files', ['files']),
  },

  beforeDestroy() {
    this.clearTempFiles();
    this.changeProcessingStatus(false);
  },

  methods: {
    ...mapActions('commercialPrintSingle', ['createCommercialPrint', 'changeProcessingStatus']),
    ...mapActions('files', ['deleteTempFiles', 'clearTempFiles']),
    ...mapActions('dialog', ['showDialog']),
    ...mapActions('snackbar', ['showSnackbar']),

    submit() {
      this.$refs.createCommercialPrintForm.validate();

      if (this.isFormValid) {
        this.createCommercialPrint({
          ...this.commercialPrint,
          files: this.files.map((el) => el.data),
        });
      } else {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
      }
    },

    showFileAddDialog() {
      this.showDialog({
        header: 'Dodawanie pliku',
        text: 'Wybierz plik i dodaj do projektu.',
        component: 'FileAdd',
      });
    },

    deleteFiles(fileIds) {
      this.deleteTempFiles(fileIds);
      this.$refs.commercialPrintFiles.clearSelection();
    },
  },
};
</script>
